export class Language {
    constructor(public code: string, public locale: string, public full: string) { }
}



// WEBPACK FOOTER //
// ./src/app/core/models/language.ts